import ContactUs from "../../Components/ContactUs";
import SmallContactForm from "../../Components/SmallContactForm";
import PageLayout from "../../Components/Common/PageLayout";
import SEO from "../../Components/Common/SEO";
import "./style.scss";

const Contact: React.FC = () => {
  return (
    <PageLayout className="Contact" showContactButton={false}>
      <SEO
        title="Contact Us | Free Window Cleaning Quote"
        description="Get in touch with Farnham and District Window Cleaning for a free, no-obligation quote. Serving Farnham, Aldershot, Alton, and nearby locations."
        canonical="https://farnhamanddistrictwindowcleaning.uk/Contact"
      />
      <ContactUs order="odd" />
      <SmallContactForm order="even" />
    </PageLayout>
  );
};

export default Contact;
